import styled from 'styled-components';

export const Container = styled.div`
  .position-badge {
    right: 4px;
    top: -8px !important;
  }
`;
